import { lazy } from 'react'

const ConfiguredServiceDetailsPage = lazy(() => import('./ConfiguredServiceDetailsPage'))
const LateFeeDetailsPage = lazy(() => import('pages/LateFeeDetailsPage'))
const ServiceGroupsPage = lazy(() => import('./ServiceGroupsPage'))
const LoginPage = lazy(() => import('./LoginPage'))
const HomePage = lazy(() => import('./HomePage'))
const ErrorPage = lazy(() => import('./ErrorPage'))
const NewRoutesPage = lazy(() => import('./NewRoutesPage'))
const MasterSequencePage = lazy(() => import('./MasterSequencePage'))
const PricingPage = lazy(() => import('./PricingPage'))
const ReportsPage = lazy(() => import('./ReportsPage'))
const ReportsDetailPage = lazy(() => import('./ReportsDetailPage'))
const ReportingShell = lazy(() => import('./ReportingShell'))
const FollowUpPage = lazy(() => import('./FollowUpPage'))
const DashboardPage = lazy(() => import('./DashboardPage'))
const AccountsPage = lazy(() => import('./AccountsPage'))
const LocationsPage = lazy(() => import('./LocationsPage'))
const SettingsPage = lazy(() => import('./SettingsPage'))
const HelpPage = lazy(() => import('./HelpPage'))
const ExportWorkOrderListPage = lazy(() => import('./ExportWorkOrderListPage'))
const NotificationsPage = lazy(() => import('./NotificationsPage'))
const ExportWorkOrderPage = lazy(() => import('./ExportWorkOrderPage'))
const BillingShell = lazy(() => import('./BillingShell'))
const WODetailsPage = lazy(() => import('./WODetailsPage'))
const AccountGroupsPage = lazy(() => import('./AccountGroupsPage'))
const AccountGroupsDetailsPage = lazy(() => import('./AccountGroupsDetailsPage'))
const SelectAccountPage = lazy(() => import('./SelectAccountPage'))
const LateFeesPage = lazy(() => import('./LateFeesPage'))
const RentalFeesPage = lazy(() => import('./RentalFeesPage'))
const RentalFeeDetailsPage = lazy(() => import('./RentalFeeDetailsPage'))
const DisposalFeesPage = lazy(() => import('./DisposalFeesPage'))
const DisposalFeeDetailsPage = lazy(() => import('./DisposalFeeDetailsPage'))
const ZonesPage = lazy(() => import('./ZonesPage'))
const ZoneDetailPage = lazy(() => import('./ZoneDetailPage'))
const CustomerListDetailsPage = lazy(() => import('./CustomerListDetailsPage'))
const NewCustomerListPage = lazy(() => import('./NewCustomerListPage'))
const TaxesPage = lazy(() => import('./TaxesPage'))
const TaxDetailPage = lazy(() => import('./TaxDetailPage'))
const InventoryContainersPage = lazy(() => import('./InventoryContainersPage'))
const InventoryContainersMovesPage = lazy(() => import('./InventoryContainersMovesPage'))
const InventoryContainerAddEditPage = lazy(() => import('./InventoryContainerAddEditPage'))
const MessagingPage = lazy(() => import('./MessagingPage'))
const InventoryContainersImportPage = lazy(() => import('./InventoryContainersImportPage'))
const ExceptionsPage = lazy(() => import('./ExceptionsPage'))

export {
  LoginPage,
  HomePage,
  ErrorPage,
  NewRoutesPage,
  MasterSequencePage,
  PricingPage,
  ReportsPage,
  ReportsDetailPage,
  ReportingShell,
  FollowUpPage,
  DashboardPage,
  AccountsPage,
  LocationsPage,
  SettingsPage,
  HelpPage,
  NotificationsPage,
  ExportWorkOrderPage,
  ExportWorkOrderListPage,
  BillingShell,
  WODetailsPage,
  AccountGroupsPage,
  AccountGroupsDetailsPage,
  SelectAccountPage,
  ServiceGroupsPage,
  LateFeesPage,
  LateFeeDetailsPage,
  RentalFeesPage,
  RentalFeeDetailsPage,
  ConfiguredServiceDetailsPage,
  DisposalFeesPage,
  DisposalFeeDetailsPage,
  InventoryContainersPage,
  InventoryContainersMovesPage,
  InventoryContainerAddEditPage,
  MessagingPage,
  InventoryContainersImportPage,
  ZonesPage,
  ZoneDetailPage,
  CustomerListDetailsPage,
  NewCustomerListPage,
  TaxesPage,
  TaxDetailPage,
  ExceptionsPage,
}
